import { gql } from 'apollo-boost';

export const SET_DAILY_REVIEW_ENABLED = gql`
    mutation(
        $enabled: Boolean!
        $emailEnabled: Boolean
        $emailFrequency: String
        $pushEnabled: Boolean
        $preferences: DailyReviewPreferencesInput
    ) {
        setDailyReviewEnabled(
            enabled: $enabled
            emailEnabled: $emailEnabled
            emailFrequency: $emailFrequency
            pushEnabled: $pushEnabled
            preferences: $preferences
        ) {
            id
            dailyReviewContentTypes
            dailyReviewExcludedFolderIds
            dailyReviewOnboardingCompleted
            dailyReviewDepth
            dailyReviewUseEmojis
            dailyReviewLanguage
            dailyReviewEnabled
            dailyReviewEmailEnabled
            dailyReviewEmailFrequency
            dailyReviewPushEnabled
        }
    }
`;
